import { all, put, takeLatest } from 'redux-saga/effects';

import {
  getAreaRequest,
  getAreaSuccess,
  getAreaFailure,
  createAreaRequest,
  createAreaFailure,
  makeMasterCheckpointsRequest,
  makeMasterCheckpointsFailure,
  removeMasterCheckpointsRequest,
  removeMasterCheckpointsFailure,
  renameAreaRequest,
  renameAreaFailure,
  updateAreaPositionRequest,
  updateAreaPositionFailure,
  areaStatusRequest,
  areaStatusFailure,
  deleteAreaRequest,
  deleteAreaFailure,
  deleteCheckpointsRequest,
  deleteCheckpointsFailure,
  addMarkerRequest,
  addMarkerFailure,
  updateNoteRequest,
  updateNoteSuccess,
  updateNoteFailure,
  deleteMarkerRequest,
  deleteMarkerFailure,
  areasSuccess,
  areasFailure,
  areasRequest,
} from './actions';

import { requestSiteInfoCP } from 'ducks/siteInfoCP/actions';
import { addArea, renameArea, pasteArea, setAreaActive, deleteArea } from '../plan-list/actions';

import axios from 'axios';
import { AREAS, SITES_V2 } from 'app/api-routes';

function* areasSaga({ payload: siteID }) {
  try {
    const { payload } = yield axios.get(`${SITES_V2}/${siteID}/areas`);

    yield put(areasSuccess(payload));
  } catch (err) {
    yield put(areasFailure(err));
  }
}

function* getAreaSaga({ payload: id }) {
  try {
    const { payload: item } = yield axios.get(`${AREAS}/${id}`);

    yield put(
      getAreaSuccess({
        id,
        item,
      })
    );
  } catch (err) {
    yield put(getAreaFailure(err));
  }
}

function* createAreaSaga({ payload: { requestPayload, parentID } }) {
  try {
    const { payload: areaID } = yield axios.post(AREAS, {
      payload: requestPayload,
    });

    yield put(
      addArea({
        parentID,
        name: requestPayload.name,
        id: areaID,
      })
    );
  } catch (err) {
    yield put(createAreaFailure(err));
  }
}

function* makeAllCheckpointsMasterSaga({ payload: { areaId, siteID } }) {
  try {
    yield axios.put(`${AREAS}/${areaId}/checkpoints-master`);
    yield put(requestSiteInfoCP(siteID));
  } catch (err) {
    yield put(makeMasterCheckpointsFailure(err));
  }
}

function* removeAllCheckpointsMasterSaga({ payload: { areaId, siteID } }) {
  try {
    yield axios.delete(`${AREAS}/${areaId}/checkpoints-master`);
    yield put(requestSiteInfoCP(siteID));
  } catch (err) {
    yield put(removeMasterCheckpointsFailure(err));
  }
}

function* renameAreaSaga({ payload: { id, name } }) {
  try {
    yield axios.put(`${AREAS}/${id}/name`, {
      payload: name,
    });
    yield put(renameArea({ id, name }));
  } catch (err) {
    yield put(renameAreaFailure(err));
  }
}

function* updateAreaPositionSaga({ payload: { areaId, parentId, type } }) {
  try {
    yield axios.put(`${AREAS}/${areaId}/parent/${type === 'area' ? parentId : 0}`);
    yield put(pasteArea({ id: `${type}-${parentId}` }));
  } catch (err) {
    yield put(updateAreaPositionFailure(err));
  }
}

function* updateNoteSaga({ payload: { id, data: item } }) {
  try {
    yield axios.put(`${AREAS}/${id}/note`, {
      payload: item,
    });

    yield put(updateNoteSuccess({ id, item }));
  } catch (err) {
    yield put(updateNoteFailure(err));
  }
}

function* areaStatusSaga({ payload: { areaId, type } }) {
  try {
    yield axios.put(`${AREAS}/${areaId}/${type}`);
    yield put(setAreaActive({ id: `area-${areaId}`, settings: { active: type === 'active' } }));
  } catch (err) {
    yield put(areaStatusFailure(err));
  }
}

function* deleteAreaSaga({ payload: areaId }) {
  try {
    yield axios.delete(`${AREAS}/${areaId}`);
    yield put(deleteArea(`area-${areaId}`));
  } catch (err) {
    yield put(deleteAreaFailure(err));
  }
}

function* deleteAllCheckpointsSaga({ payload: { areaId, siteID } }) {
  try {
    yield axios.delete(`${AREAS}/${areaId}/checkpoints`);
    yield put(requestSiteInfoCP(siteID));
  } catch (err) {
    yield put(deleteCheckpointsFailure(err));
  }
}

function* addAreaMarkerSaga({ payload: { areaId, markerArea, assetID } }) {
  try {
    yield axios.put(
      `${AREAS}/${areaId}/marker`,
      {
        payload: markerArea,
      },
      {
        params: {
          assetID,
        },
      }
    );
    yield put(getAreaRequest(areaId));
  } catch (err) {
    yield put(addMarkerFailure(err));
  }
}

function* deleteAreaMarkerSaga({ payload: { areaId, assetID } }) {
  try {
    yield axios.delete(`${AREAS}/${areaId}/marker?assetID=${assetID}`);
    yield put(getAreaRequest(areaId));
  } catch (err) {
    yield put(deleteMarkerFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(areasRequest, areasSaga),
    yield takeLatest(getAreaRequest, getAreaSaga),
    yield takeLatest(createAreaRequest, createAreaSaga),
    yield takeLatest(makeMasterCheckpointsRequest, makeAllCheckpointsMasterSaga),
    yield takeLatest(removeMasterCheckpointsRequest, removeAllCheckpointsMasterSaga),
    yield takeLatest(renameAreaRequest, renameAreaSaga),
    yield takeLatest(updateAreaPositionRequest, updateAreaPositionSaga),
    yield takeLatest(areaStatusRequest, areaStatusSaga),
    yield takeLatest(deleteAreaRequest, deleteAreaSaga),
    yield takeLatest(deleteCheckpointsRequest, deleteAllCheckpointsSaga),
    yield takeLatest(updateNoteRequest, updateNoteSaga),
    yield takeLatest(addMarkerRequest, addAreaMarkerSaga),
    yield takeLatest(deleteMarkerRequest, deleteAreaMarkerSaga),
  ]);
}
